import _ from 'lodash';

const defaultValue = {active: false};
const versionInProfile = _.get(window, 'appConfig.featureSwitch.versionInProfile', defaultValue);
const extendedHttpHeaders = _.get(window, 'appConfig.featureSwitch.extendedHttpHeaders', defaultValue);
const clinicalReportSummarizer = _.get(window, 'featureSwitchConfig.clinicalReportSummarizer', defaultValue);

export default {
    versionInProfile,
    extendedHttpHeaders,
    clinicalReportSummarizer
};
